import { Stack, Typography, Pagination as MuiPagination } from "@mui/material";
import { PaginationContainer, PaginationContent } from "./styles";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChangePage: (page: number) => void;
  size?: "small" | "medium" | "large";
}

export function Pagination({
  currentPage,
  totalPages,
  onChangePage,
  size = "medium",
}: PaginationProps) {
  const safeTotal = Math.max(totalPages, 1);
  const safePage = Math.min(Math.max(currentPage, 1), safeTotal);

  const handleChange = (_event: unknown, page: number) => {
    if (page === safePage) {
      return;
    }
    onChangePage(page);
  };

  return (
    <PaginationContainer>
      <Stack spacing={1} alignItems="center">
        <PaginationContent>
          <MuiPagination
            count={safeTotal}
            page={safePage}
            onChange={handleChange}
            showFirstButton
            showLastButton
            color="primary"
            variant="outlined"
            shape="rounded"
            size={size}
          />
        </PaginationContent>
        <Typography variant="caption" color="text.secondary">
          Página {safePage} de {safeTotal}
        </Typography>
      </Stack>
    </PaginationContainer>
  );
}
